import moment from 'moment';
import { LoggingService } from '../shared/services/logging/logging.service';
const log = new LoggingService();

export default function formatDateProperties(item: any): any {
    if (!item) {
        return item;
    }
    const newObject = { ...item };
    const keys = Object.keys(item);
    keys.forEach(key => {
        if (item.hasOwnProperty(key)) {
            let value = item[key];
            if (Array.isArray(value)) {
                value = value.map(x => formatDateProperties(x));
            }
            if (value instanceof Date) {
                log.verbose({ type: 'formatDateProperties', value });
                value = moment(value).format('YYYY-MM-DDTHH:mm:ss');
                log.verbose({ type: 'formatDateProperties', value });
            }
            // if (key.toLocaleLowerCase().includes('date')) {
            // let mdate = moment(value, 'MM-DD-YYYY');
            // if (mdate.isValid()) {
            //     if (mdate.parsingFlags().unusedTokens.length === 0) {
            //         value = moment(value).format('MM-DD-YYYY');
            //     }
            // }
            // mdate = moment(value, 'YYYY-MM-DD');
            // if (mdate.isValid()) {
            //     if (mdate.parsingFlags().unusedTokens.length === 0) {
            //         value = moment(value).format('MM-DD-YYYY');
            //     }
            // }
            // }
            newObject[key] = value;
        }
    });
    return newObject;
}
